export enum CaseLineFields {
  DISTANCE_RUN = 'distance_run',
  FACTORY_CODE = 'factory_code',
  PRODUCT_CODE = 'product_code',
  DEFECT_REASON = 'defect_reason',
  PURCHASE_DATE = 'purchase_date',
}
